import Table from './table';
import Summary from './summary/index';
var TableComponent = Table;
TableComponent.Summary = Summary;
export default TableComponent;
